import React, { Component } from "react";
import { BrowserRouter as Router, Redirect } from "react-router-dom";
import Route from "react-router-dom/Route";
import Home from "./components/home/home.js";
import Dashboard from "./components/dashboard/dashboard.js";
import Login from "./components/login/login.js";
import Signup from "./components/signup/signup.js";
// import Navbar from "./components/navbar/navbar.js";
import Contact from "./components/contact/contact.js";
import About from "./components/about/about.js";
import "./components/login/index.js";
import "./App.css";
import Privacy from "./components/privacypolicy/privacy";
import Press from "./components/press/Press.js"
class App extends Component {
    constructor() {
        super();
        this.state = {
            userinfo: "",
            loggedIn: false,
            loaded: false,
            authenticated: false,
            currentYear: ""
        };
    }

    componentDidMount() {
        var currentTime = new Date();
        var year = currentTime.getFullYear();
        this.setState({
            currentYear: year
        });
    }

    updateAuthentication(user) {
        this.setState({
            authenticated: true
        });
    }

    handleUserInfo = userinfo => {
        this.setState({ userinfo: userinfo });
    };

    handleLogout(event) {
        event.preventDefault();
    }

    render() {
        return (
            <div>
                <Router>
                    <div>
                        <Route path={"/"} exact render={() => (this.state.authenticated ?
                            <Dashboard userInfo={this.state.userinfo} isAuthenticated={this.state.authenticated} /> :
                            <Home />)} />
                        <Route path={"/about"} exact component={About} />
                        <Route path={"/contact"} exact component={Contact} />
                        <Route path={"/press"} exact component={Press} />
                        <Route
                            path={"/signup"}
                            exact
                            strict
                            render={() => (this.state.authenticated ? <Redirect to="/dashboard" /> :
                                <Signup onGetUserInfo={this.handleUserInfo.bind(this)}
                                    action={this.updateAuthentication.bind(this)} />)}
                        />
                        <Route
                            path={"/login"}
                            exact
                            strict
                            render={() => (this.state.authenticated ? <Redirect to="/dashboard" /> :
                                <Login onGetUserInfo={this.handleUserInfo.bind(this)}
                                    action={this.updateAuthentication.bind(this)} />)}
                        />
                        <Route path={"/privacy-policy"} exact component={Privacy} />
                        {/* <Route path={"/user/:username"} exact component={User} /> */}
                        {this.state.authenticated ? (
                            <Route path={"/dashboard"} exact render={() => <Dashboard userInfo={this.state.userinfo}
                                isAuthenticated={this.state.authenticated} />} />
                        ) : (
                                <Route path={"/dashboard"} exact render={() => <Home />} />
                            )}
                    </div>
                </Router>
                <p className="signature">{`All Rights Reserved © ${this.state.currentYear} Espire`}</p>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js